import React from 'react';
import { Loader2, Check, Circle } from 'lucide-react';

interface ImportBuildProgressProps {
  progress: Array<{ title: string; status: 'pending' | 'in_progress' | 'done'; pageId?: string }>;
  builtSiteId: string | null;
  onCancel?: () => void;
}

export const ImportBuildProgress: React.FC<ImportBuildProgressProps> = ({
  progress,
  builtSiteId,
  onCancel,
}) => {
  const done = progress.filter(p => p.status === 'done').length;
  return (
    <div className="flex flex-col h-full bg-slate-900 text-white">
      <div className="px-6 py-4 border-b border-slate-800">
        <div className="flex items-center gap-2 text-orange-400 mb-1">
          <Loader2 className="w-4 h-4 animate-spin" />
          <span className="text-xs font-semibold uppercase tracking-wider">Building</span>
        </div>
        <h2 className="text-lg font-semibold">Roary is building your site</h2>
        <p className="text-sm text-slate-400 mt-1">
          {done} of {progress.length} pages
          {builtSiteId ? ' · site created' : ''}
        </p>
      </div>

      <div className="flex-1 overflow-y-auto px-6 py-4">
        <ul className="space-y-2">
          {progress.map((p, i) => (
            <li
              key={i}
              className="flex items-center gap-3 px-3 py-2 rounded-md bg-slate-800/40 border border-slate-800"
            >
              {p.status === 'done' && <Check size={16} className="text-green-400 flex-shrink-0" />}
              {p.status === 'in_progress' && (
                <Loader2 size={16} className="text-orange-400 animate-spin flex-shrink-0" />
              )}
              {p.status === 'pending' && (
                <Circle size={16} className="text-slate-600 flex-shrink-0" />
              )}
              <span className={p.status === 'done' ? 'text-slate-200' : 'text-slate-400'}>
                {p.title}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {onCancel && (
        <div className="px-6 py-3 border-t border-slate-800">
          <button
            type="button"
            onClick={onCancel}
            className="px-3 py-1.5 text-sm text-slate-400 hover:text-white transition-colors"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
